import { useAffiliateTracking } from "@/hooks/useAffiliateTracking";

const AffiliateTrackingWrapper = () => {
  // Inicializar o tracking de afiliados para capturar códigos da URL
  useAffiliateTracking();
  
  // Este componente não renderiza nada, apenas executa o hook
  return null;
};

export default AffiliateTrackingWrapper;